import React from "react";
import { DragDropContext } from "@hello-pangea/dnd";

import SuiviClientsColumn from "./SuiviClientsColumn";
import useHorizontalDragScroll from "../hooks/useHorizontalDragScroll";

export default function SuiviClientsBoard({
  columns,
  loading,
  onDragEnd,
  onOpenAssociation,
  onCreateCard,
  allCardsExpanded,
  expandedCardIds,
  onToggleCardExpanded,
}) {
  const { scrollRef, isDraggingScroll, dragScrollHandlers } =
    useHorizontalDragScroll();

  if (loading) {
    return (
      <div className="flex flex-1 gap-5 overflow-hidden px-5 py-4">
        {[1, 2, 3, 4, 5, 6, 7].map((item) => (
          <div
            key={item}
            className="h-[calc(100vh-230px)] w-[312px] shrink-0 animate-pulse rounded-3xl border border-white/15 bg-white/60 shadow-xl"
          />
        ))}
      </div>
    );
  }

  if (!columns?.length) {
    return (
      <div className="flex flex-1 items-center justify-center px-5 py-8">
        <div className="rounded-3xl border border-white/20 bg-white/90 px-8 py-7 text-center shadow-2xl backdrop-blur">
          <div className="text-5xl">📭</div>
          <h2 className="mt-3 text-xl font-bold text-slate-900">
            Aucun résultat
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Aucune colonne ne contient de carte avec ces filtres.
          </p>
        </div>
      </div>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div
        ref={scrollRef}
        {...dragScrollHandlers}
        className={`suivi-clients-scrollbar-hidden flex flex-1 cursor-grab gap-5 overflow-x-auto overflow-y-hidden px-5 py-5 active:cursor-grabbing ${
          isDraggingScroll ? "select-none" : ""
        }`}
      >
        {(columns || []).map((column) => (
          <SuiviClientsColumn
            key={column.id}
            column={column}
            onOpenAssociation={onOpenAssociation}
            onCreateCard={onCreateCard}
            allCardsExpanded={allCardsExpanded}
            expandedCardIds={expandedCardIds}
            onToggleCardExpanded={onToggleCardExpanded}
          />
        ))}

        <div className="flex h-fit w-[312px] shrink-0 cursor-default flex-col gap-3 rounded-3xl border border-dashed border-white/25 bg-white/10 p-4 text-white/85 backdrop-blur">
          <div className="text-sm font-bold">Pipeline commercial</div>
          <p className="text-xs leading-relaxed text-white/60">
            Les colonnes sont pilotées par le statut de l’association.
            Ajoute une carte depuis une colonne existante pour conserver la
            logique actuelle.
          </p>
        </div>
      </div>

      <style>{`
        .suivi-clients-scrollbar-hidden {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .suivi-clients-scrollbar-hidden::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </DragDropContext>
  );
}